import { useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useToast } from "@chakra-ui/react";

import { useKy } from "src/common/ky";
import { GET_STAFF_LIST_QUERY_KEY } from "src/routes/Staff/queries";

export const useDeleteStaff = () => {
  const ky = useKy();
  const queryClient = useQueryClient();

  const [deletingStaffId, setDeletingStaffId] = useState<string | undefined>();
  const deleteStaffMemberMutation = useMutation(
    () => ky.delete(`staff-users/${deletingStaffId}`),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(GET_STAFF_LIST_QUERY_KEY);
        setDeletingStaffId(undefined);
      },
    }
  );

  return {
    isDeletingStaff: !!deletingStaffId,
    deleteStaffMemberMutation,
    setDeletingStaffId,
  };
};

export const useResetStaffPassword = () => {
  const ky = useKy();
  const queryClient = useQueryClient();
  const toast = useToast();

  const [resettingStaffId, setResettingStaffId] = useState<
    string | undefined
  >();
  const resetStaffPasswordMutation = useMutation(
    () => ky.post(`staff-users/${resettingStaffId}/reset-password`),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(GET_STAFF_LIST_QUERY_KEY);
        setResettingStaffId(undefined);
        toast({
          description: "Password Reset Successful!",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      },
    }
  );

  return {
    isResettingStaff: !!resettingStaffId,
    resetStaffPasswordMutation,
    setResettingStaffId,
  };
};
